export default __webpack_public_path__ + "static/media/H1001b.7757626c.mp3";